import { render, staticRenderFns } from "./PostoColetaComponente.vue?vue&type=template&id=29a2dd7d&scoped=true"
import script from "./PostoColetaComponente.vue?vue&type=script&lang=js"
export * from "./PostoColetaComponente.vue?vue&type=script&lang=js"
import style0 from "./PostoColetaComponente.vue?vue&type=style&index=0&id=29a2dd7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2dd7d",
  null
  
)

export default component.exports